import {createStyles} from '@mantine/core';
import React from 'react';

import {TransitionSource} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorConstants';

export function getTransitionSourceLabel(transitionSource: TransitionSource): string {
  switch (transitionSource) {
    case TransitionSource.OUTPUTS:
      return 'outputs';
    case TransitionSource.INPUTS:
      return 'tasks';
    default:
      throw new Error(`Unexpected transition source: ${transitionSource}`);
  }
}

/**
 * Static (read-only) description of a transition source, e.g.
 * "Uses **outputs** to create tasks & populate fields".
 * Used in both the transitions tab and the field-level mapping cards.
 */
export function StaticTransitionSourceDescription(props: {
  transitionSource: TransitionSource;
  className?: string;
}): JSX.Element {
  return (
    <div className={props.className}>
      Uses <strong>{getTransitionSourceLabel(props.transitionSource)}</strong> to create tasks &amp; populate
      fields
    </div>
  );
}

export const useTransitionCardStyles = createStyles((theme) => ({
  chipNormalWeight: {
    fontWeight: 'normal' as const,
  },
  displayOnlyChip: {
    '&.chip, &.chip:hover, &.chip:focus, &.chip:focus-visible, &.chip:active': {
      backgroundColor: theme.colors.gray[2],
      borderColor: theme.colors.gray[2],
      outline: 'none',
    },
  },
  flushTable: {
    marginBottom: 0,
    borderTop: `1px solid ${theme.colors.gray[2]}`,
    borderRadius: 0,
  },
}));
